module.exports = __webpack_public_path__ + "static/img/spec-left.ec90b3f1.png";